import { create } from 'zustand';
import { FileUtils } from '@shared/utils';
import { ApiUtils, FileApi } from '@shared/api';

interface UseDownloadFileStore {
  loading: boolean;
  error: string | null;
  downloadFile: (request: { fileId: string; filename: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useDownloadFileStore = create<UseDownloadFileStore>((set) => ({
  loading: false,
  error: null,

  downloadFile: async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await FileApi.downloadFile(request.fileId, signal);
      FileUtils.downloadFile(result, request.filename);
      set({ loading: false });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  },

  clear: () => set({ loading: false, error: null }),
}));
